<label class="container" ngClass={{radioClass}}><div class="radiobutton__text">{{radioText}}</div>
    <input type="radio"  name="radio">
    <span class="checkmark"></span>
</label>
  